// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"553":"14214570","619":"8e9e3130","996":"d4955aa3"}[chunkId] + ".chunk.css";
};